import { z } from 'zod';
import { paginationQuerySchema } from '../common/pagination.js';
export const groupStatusSchema = z.enum(['ACTIVE', 'INACTIVE']);
export const createGroupSchema = z.object({
    nameAr: z.string().trim().min(1).max(120),
    nameEn: z.string().trim().min(1).max(120),
    descriptionAr: z.string().trim().max(500).optional(),
    descriptionEn: z.string().trim().max(500).optional(),
});
export const updateGroupSchema = createGroupSchema.partial();
export const changeGroupStatusSchema = z.object({ status: groupStatusSchema });
export const setGroupServicesSchema = z.object({ serviceIds: z.array(z.string()) });
export const groupListQuerySchema = paginationQuerySchema.extend({
    status: groupStatusSchema.optional(),
});
//# sourceMappingURL=contract.js.map